import { string } from 'yup'
import { safify } from '../utils/safify'

export const contentType = string()
  .required()
  .oneOf([
    'Emails',
    'Ads',
    'Social Media',
    'Website',
    'Marketplace',
    'Product descriptions',
    'Video',
    'Recruiting',
    'Sales',
    'Customer Service',
  ])
  .default('Social Media')
  .meta({ label: 'What type of content are you working on?', autoFill: false, oneOfPills: true })
  .transform(safify)
